import {
  type ConversationViewModelFactory,
  type MessageBankDialogViewModelFactory,
  type MessagingFeatureOptions,
  type RoomViewModelFactory,
} from '@/features/messaging'
import { MessagingApi } from './api/messaging-api'
import { ConversationViewModel } from './ConversationViewModel'
import { MessageBankDialogViewModel } from './message-bank/MessageBankDialog/MessageBankDialogViewModel'
import { MessageBankStore } from './message-bank/MessageBankStore'
import { RoomStore } from './rooms/RoomStore'
import { RoomViewModel } from './rooms/RoomViewModel'
import { env } from '@/infra/env'
import { ConversationStore } from './ConversationStore'

export function InternalMessagingFeature(options: MessagingFeatureOptions) {
  const messagingApi = new MessagingApi({
    baseURL: env.MESSAGE_API,
    token$: options.token$,
  })

  const conversationStore = new ConversationStore(
    messagingApi,
    options.primeWorkspace,
    options.primeMemberByPublicId,
    options.primeUser,
    options.getCurrentUser,
    options.currentUser$,
    options.pageActivity$,
    options.userActive$,
  )

  const roomStore = new RoomStore(
    messagingApi,
    options.primeMemberByPublicId,
    conversationStore.primeConversation,
  )

  const messageBankStore = new MessageBankStore(
    messagingApi.messageBanks,
    options.primeWorkspace,
  )

  conversationStore.incomingMessages$.subscribe(() =>
    options.playSound('GotMessage'),
  )

  const createConversationViewModel: ConversationViewModelFactory = (
    getConversation,
    team,
    conversationOptions,
  ) =>
    new ConversationViewModel(
      getConversation,
      team,
      conversationOptions,
      conversationStore,
      options.newAlert,
      options.createAlertErrorHandler,
      options.createAlertRetryWrapper,
      options.getCurrentMember,
      options.jobProgression,
    )

  const createRoomViewModel: RoomViewModelFactory = (getRoomId) =>
    new RoomViewModel(
      getRoomId,
      roomStore,
      options.getCurrentMember,
      options.getExternalUrlDelegate,
      options.createAlertErrorHandler,
    )

  const createMessageBankDialogViewModel: MessageBankDialogViewModelFactory = (
    getWorkspaceId,
    onReplySelected,
  ) =>
    new MessageBankDialogViewModel(
      getWorkspaceId,
      onReplySelected,
      messageBankStore,
    )

  return {
    // Internal
    conversationStore,
    roomStore,
    messageBankStore,
    createConversationViewModel,
    createRoomViewModel,
    createMessageBankDialogViewModel,
  }
}
